/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit Tysiav2WorkHours/view.blocks to change it.
import * as fromDesignTokens from 'Simple/DesignTokens'
import React from 'react'
import styles from './view.module.css'



/** @type {import('Simple/types.js').View} */
export default function Tysiav2WorkHours({
  children,
  viewPath = "/DesignSystem/Svgs/Tysiav2WorkHours",
  alignSelf = "auto",
  marginTop = 0,
  marginBottom = 0,
  marginLeft = 0,
  marginRight = 0,
  opacity = 1,
  width = 24,
  height = 24,
  fill = "none",
  isAnimated,
  animation = "dash 5s linear forwards",
  strokeDashoffset = 1000,
  strokeDasharray = 1000,
  fill2
  
}) {
let dtColorsBlack = fromDesignTokens.useDesignTokenValue({
          viewPath,
          path: 'colors.black'
        })
let fill2OrdtColorsBlack = fill2 ?? dtColorsBlack
  return (<React.Fragment
>
<svg
  data-testid="Tysiav2WorkHours.Svg"
  data-view-path={viewPath}
 viewBox="0 0 24 24"
 style={{'--as-1-Z1gjQBz': alignSelf,'--mt-2-Z1gjQBz': typeof marginTop === 'number' ? `${marginTop}px` : marginTop,'--mb-3-Z1gjQBz': typeof marginBottom === 'number' ? `${marginBottom}px` : marginBottom,'--ml-4-Z1gjQBz': typeof marginLeft === 'number' ? `${marginLeft}px` : marginLeft,'--mr-5-Z1gjQBz': typeof marginRight === 'number' ? `${marginRight}px` : marginRight,'--o-6-Z1gjQBz': opacity,'--w-10-Z1gjQBz': typeof width === 'number' ? `${width}px` : width,'--h-11-Z1gjQBz': typeof height === 'number' ? `${height}px` : height,'--f-12-Z1gjQBz': fill,'--a-7-Z1gjQBz': isAnimated ? animation : "none",'--sd-8-Z1gjQBz': isAnimated ? strokeDashoffset : 0,'--sd-9-Z1gjQBz': isAnimated ? strokeDasharray : 0}}
 className={`views-block ${styles.Svg}`}
>
<path
  data-testid="Tysiav2WorkHours.SvgPath"
  data-view-path={viewPath}
 fillRule="evenodd"
 clipRule="evenodd"
 d="M11.495 2.21A.714.714 0 0112 2a10 10 0 0110 10 .715.715 0 01-.714.714H12a.714.714 0 01-.714-.714V2.714c0-.19.075-.37.209-.505zM13.07 19.5a1.071 1.071 0 00-2.142 0v1.429a1.071 1.071 0 002.142 0V19.5zM2 12c0-.592.48-1.071 1.071-1.071H4.5a1.071 1.071 0 110 2.142H3.071C2.48 13.071 2 12.591 2 12zm4.444-7.071A1.071 1.071 0 104.93 6.444l1.23 1.23a1.071 1.071 0 001.515-1.516l-1.23-1.23zm9.882 11.397a1.072 1.072 0 011.516 0l1.23 1.23a1.071 1.071 0 11-1.516 1.515l-1.23-1.23a1.071 1.071 0 010-1.515zm-8.652 1.515a1.071 1.071 0 10-1.516-1.515l-1.23 1.23a1.072 1.072 0 001.516 1.515l1.23-1.23z"
 style={{'--f-12-Z1gjQBz': fill2OrdtColorsBlack}}
 className={`views-block ${styles.SvgPath}`}
/>
</svg>
{children}
</React.Fragment>)
}